import React, { useEffect, useRef, useState } from 'react';
import axiosInstance from '../axiosInstance';

const RecalcUser = () => {
  const requestSent = useRef(false); // Track if the request has been sent
  const [message, setMessage] = useState(null); // State to display success message

  useEffect(() => {
    if (requestSent.current) return; // Prevent duplicate requests
    requestSent.current = true;

    const urlParts = window.location.pathname.split('/');
    const userId = urlParts[2]; // Extract the user ID from the URL

    axiosInstance.post(`/user/${userId}/recalc`)
      .then(response => {
        console.log('Recalculation successful:', response.data);
        setMessage('Calculation began'); // Set success message
      })
      .catch(error => {
        console.error('Error during recalculation:', error);
      });
  }, []);

  return (
    <div>
      {message && <div style={{ color: 'green' }}>{message}</div>}
      {!message && <div>Recalculation in progress...</div>}
    </div>
  );
};

export default RecalcUser;
